<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      :persistent='true'
      width="60%"
      height="100%"
      class="modalDialog"
      no-click-animation
    >
      <CardTitle :title="pageTitle" />
      <v-card-actions class="cardWrap__scroll">
        <v-container>
          <v-form
            class="cardWrap__fromArea"
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-row justify="space-around" class="formHeight">
              <v-col cols="4">配信日</v-col>
              <v-col cols="8">
                <span style="padding-left: 10px;">{{ fromSetData.delivery_date }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">天気及びその他連絡事項</v-col>
              <v-col cols="8">
                <v-textarea
                  v-model="fromSetData.delivery_contents"
                  :rules="[rules.checkEmpty]"
                  auto-grow
                  rows="10"
                  maxlength="30"
                />
              </v-col>
            </v-row>
            <!-- <v-row justify="start">
              <div class="cardWrap__fromArea__title">有効フラグ</div>
                <v-checkbox v-model="fromSetData.valid_flag" class="mx-2" label="有効フラグ" />
            </v-row> -->
          </v-form>
        </v-container>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
        <v-btn color="green darken-4" text v-if="addModeStatus" @click="OnConfirmOverlay">登録</v-btn>
        <v-btn color="green darken-4" text v-if="changeModeStatus" @click="OnConfirmOverlay">変更</v-btn>
      </v-card-actions>
      <AddOverLay
        :page-name="OverLayPageName"
        @processing="OnRunMutation"
        @cancel="closeAddOverLay"
        :process-result="process"
        :OverlaySwitch="addOverlay"
      />
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import validater from '../../../lib/validater';
import { CODE_MASTER } from '../../config';
import AddOverLay from '@/components/overlay/AddOverlay';
import { UPDATE_DELIVERY, REGISTER_DELIVERY } from '@/constants/delivery';

export default {
    components: {
        CardTitle,
        AddOverLay
    },
    props: [
        'dayList'
    ],
    data () {
        return {
            pageTitle: null,
            dialog: false,
            changeModeStatus: false,
            addModeStatus: false,
            valid: true,
            rules: {
                checkEmpty: value => validater.checkEmptyString(value) || this.$t('error.validation.required.any')
            },
            fromSetData: {
                delivery_id: '',
                delivery_date: '',
                delivery_contents: ''
            },
            process: {
                result: '',
                resultText: '',
                btnDisabled: 0
            },
            OverLayPageName: '',
            addOverlay: false
        };
    },
    methods: {
    /** ----------------------------------------------
     * 初期表示時処理
     * ---------------------------------------------- */
        Initialize () {
            this.addModeStatus = false;
            this.changeModeStatus = false;
            this.addOverlay = false;
            this.changeOverlay = false;
            this.fromSetData = {
                delivery_id: '',
                delivery_date: '',
                delivery_contents: ''
            };
        },
        /** ----------------------------------------------
         * 変更
         * ---------------------------------------------- */
        UpdateDelivery: async function () {
            if (this.$refs.form.validate()) {
                try {
                    await this.$apollo.mutate({
                        mutation: UPDATE_DELIVERY,
                        variables: {
                            delivery_id: this.fromSetData.delivery_id,
                            delivery_date: this.fromSetData.delivery_date,
                            delivery_contents: this.fromSetData.delivery_contents
                        }
                    }).then(res => {
                        this.dialog = false;
                        this.$emit('from-Dialog');
                    });
                } catch (error) {
                    this.process.result = '1';
                    this.process.resultText = this.$t('result.error.change');
                    this.error = error;
                }
            }
        },
        /** ----------------------------------------------
         * 追加
         * ---------------------------------------------- */
        RegistDelivery: async function () {
            if (this.$refs.form.validate()) {
                try {
                    await this.$apollo.mutate({
                        mutation: REGISTER_DELIVERY,
                        variables: {
                            delivery_id: CODE_MASTER.DELIVERY_SAMEDAY_CONTACT,
                            delivery_date: this.fromSetData.delivery_date,
                            delivery_contents: this.fromSetData.delivery_contents
                        }
                    }).then(res => {
                        this.dialog = false;
                        this.$emit('from-Dialog');
                    });
                } catch (error) {
                    this.process.result = '1';
                    this.process.resultText = this.$t('result.error.regist');
                    this.error = error;
                }
            }
        },
        /** --------------------------------------------
        * モーダル画面を表示
        * -------------------------------------------- */
        EditModal (item) {
            this.Initialize();
            this.fromSetData.delivery_id = item.delivery_id;
            this.fromSetData.delivery_date = item.delivery_date;
            this.fromSetData.delivery_contents = item.delivery_contents;
            this.changeModeStatus = true;
            this.dialog = true;
            this.pageTitle = this.fromSetData.delivery_id ? '変更' : '登録';
            this.$nextTick(function () {
                this.$refs.form.resetValidation();
            });
        },
        /** --------------------------------------------
        * 確認画面を表示
        * -------------------------------------------- */
        OnConfirmOverlay: function () {
            if (this.$refs.form.validate()) {
                this.addOverlay = !this.addOverlay;
                this.OverLayPageName = '当日連絡事項';
            }
        },
        /** --------------------------------------------
        * 処理を実行
        * -------------------------------------------- */
        OnRunMutation: function () {
            // delivery_idを持っていなければ新規登録
            if (this.fromSetData.delivery_id) {
                this.UpdateDelivery();
            } else {
                this.RegistDelivery();
            }
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.dialog = false;
            this.$emit('from-Dialog');
            this.Initialize();
        },
        /** ----------------------------------------------
         * 確認ダイアログを閉じる
         * ---------------------------------------------- */
        closeAddOverLay () {
            this.$set(this.process, 'result', '');
            this.addOverlay = false;
        }
    }
};
</script>

<style scoped>

.formHeight{
  max-height: 60px;
  max-width: 100%;
}

.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}
</style>
